// Geneva expects <= 2 to be of 'error' classification
export var LoggingLevel;
(function (LoggingLevel) {
    LoggingLevel[LoggingLevel["error"] = 0] = "error";
    LoggingLevel[LoggingLevel["warn"] = 1] = "warn";
    LoggingLevel[LoggingLevel["info"] = 3] = "info";
    LoggingLevel[LoggingLevel["metric"] = 4] = "metric";
    LoggingLevel[LoggingLevel["verbose"] = 5] = "verbose";
    LoggingLevel[LoggingLevel["debug"] = 6] = "debug";
})(LoggingLevel || (LoggingLevel = {}));
// This prevents empty objects from being included in JSON.stringify. Helpful for 'custom{X}Fields'
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var stringifyReplacer = function (_key, value) {
    if (typeof value == 'object' && Object.keys(value).length == 0) {
        return undefined;
    }
    else {
        return value;
    }
};
//# sourceMappingURL=ilogger.js.map